module.exports = __webpack_public_path__ + "img/sbb_bg.c0a8a559.png";